/* eslint-disable no-unused-vars */
// import core & vendor packages below
import { Modal, Button } from 'react-bootstrap';

// import components below
import ModalUI from 'components/UI/ModalUI';

// import assets below
import './ConfirmationModal.scss';
import { ReactComponent as CloseSVG } from 'assets/svg/circle-xmark.svg';
// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SucessModal from './SuccessModal';
import { useState } from 'react';
import { toast } from 'react-toastify';

// main componet
// eslint-disable-next-line no-unused-vars
const ConfirmationModal = ({ setOpenModal, params, uploadedFiles, setUploadedFiles }) => {

    const [modal, setModal] = useState(false);
    const navigate = useNavigate();

    const closeModal = () => {
        setOpenModal(false);
    };

    const createNewPatient = async () => {
        await axios
            .put('/patient', params)
            .then((response) => {
                if (response.data.error) {
                    alert(response.data.error.message);
                } else {
                    setOpenModal(false);
                    toast.success('Successfully edited!');
                    setTimeout(() => {
                        navigate('/dashboard/outpatient-department');
                    }, 2000);
                    
                    const formdata = new FormData();
                    
                    for (const key of Object.keys(uploadedFiles)) {
                    formdata.append('FILES', uploadedFiles[key]);
                    }

                    formdata.append('patientId', params?.id);

                    // setModal(true);
                    axios.post('/patient/file_upload', formdata)
                    .then((response) => {
                        setUploadedFiles([]);
                    }, [])
                    .catch((err) => {
                        err?.response?.data?.errors.map((item) => {
                            toast.warning(item.msg + ' ' + item.param);
                        });
                    });
                }
            })
            .catch((err) => {
                console.log('AXIOS ERROR: ', err);
            });
    };

    return (
        <div className='loginModal'>
            <ModalUI>
                <Modal.Dialog>
                    <Modal.Header id='confirmation-modal-header'>
                        <h6>CONFIRMATION</h6>
                        <Button onClick={closeModal}>
                            <CloseSVG />
                        </Button>
                    </Modal.Header>
                    <Modal.Body>

                        <p>
                            A patient record will be edited
                        </p>
                        <p>
                            Are you sure you want to continue?
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button className='loginModal__button' onClick={createNewPatient}>
                            SAVE PATIENT INFORMATION
                        </Button>
                    </Modal.Footer>
                </Modal.Dialog>
            </ModalUI>
            {modal && <SucessModal />}
        </div>
    );
};

export default ConfirmationModal;
